import jsPDF from 'jspdf';

import { dateFormatted, dateLongFormatted } from 'src/app/helpers/DateHelper';
import { convertToCurrency } from 'src/app/helpers/StringHelper';

import { AdyenRefundDataReport } from '../types/customer';

const forty = 40;
const twenty = 20;
const oneHundredSeventy = 170;
const eighty = 80;
const oneHundredTwenty = 120;
const two = 2;
const sixteen = 16;
const oneHundredFiftyFive = 155;
const eleven = 11;
const oneHundredEightyFive = 185;
const twoHundredFive = 205;
const fiveHundred = 500;
const fourHundredForty = 440;
const twoHundredEighty = 280;
const threeHundredSixty = 360;

export function customerRefundPdf(data: AdyenRefundDataReport) {
  if (data) {
    const doc = new jsPDF('p', 'pt');

    const img = new Image();
    img.src = `${window.location.origin}/static/logos/logoQueimaDiaria.png`;
    doc.addImage(img, 'PNG', forty, twenty, oneHundredSeventy, eighty);

    doc.setFontSize(eleven);

    doc.text(
      `São Paulo, ${dateLongFormatted(data.createdAt, false)}`,
      forty,
      oneHundredTwenty
    );

    doc.setFontSize(sixteen);
    const pageWidth = doc.internal.pageSize.getWidth();
    doc.text(
      'Carta de Cancelamento de Transação',
      pageWidth / two,
      oneHundredFiftyFive,
      {
        align: 'center',
      }
    );

    doc.setFontSize(eleven);

    doc.text(
      'Nós gostaríamos de informar que cancelamos a transação abaixo:',
      forty,
      oneHundredEightyFive
    );

    doc.text(
      [
        `Cliente: ${data.customer.fullName}`,
        `Referência do Pagamento: ${data.paymentInfo.paymentRef}`,
        `Data do Pagamento: ${dateFormatted(
          data.paymentInfo.paymentDate,
          false
        )}`,
        `Valor do Pagamento: BRL ${convertToCurrency(data.paymentInfo.amount)}`,
        `Modalidade do Pagamento: ${data.paymentInfo.paymentRef}`,
      ],
      forty,
      twoHundredFive
    );

    doc.text(
      [
        `Referência do Cancelamento: ${data.cancellationInfo.cancellationRef}`,
        `Valor do Cancelamento: BRL ${convertToCurrency(
          data.cancellationInfo.cancellationAmount
        )}`,
        `Data do Cancelamento: ${dateFormatted(
          data.cancellationInfo.cancellationDate,
          false
        )}`,
      ],
      forty,
      twoHundredEighty
    );

    doc.text(
      [
        `Número do Cartão: ${data.cardNumber}`,
        `Código do Estabelecimento: ${data.establishment}`,
        `Nome do Comerciante: ${data.merchantName}`,
      ],
      forty,
      threeHundredSixty
    );

    const splitTitle = doc.splitTextToSize(
      `Este documento foi criado para ajudar o emissor do cartão a encontrar o ` +
        `reembolso sob o numero da transação ${data.cancellationInfo.cancellationRef}. ` +
        `Guarde este comunicado, pois ele ira auxilia-lo em seus controles. ` +
        `Para mais informações, entre em contato com a QueimaDiária.`,
      fiveHundred
    );
    doc.text(splitTitle, forty, fourHundredForty);

    doc.save(`${data.paymentInfo.gatewayTransaction}_adyen_refund.pdf`);
  }
}
